import React, { useEffect, useState } from "react";
import { useUser } from "./UserContext";

export default function UserProfile() {
  const { user, login, logout } = useUser();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  // Şifre değiştirme için state
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState("");

  useEffect(() => {
    if (user?.id) {
      setLoading(true);
      fetch(`/api/users/${user.id}`)
        .then(res => res.json())
        .then(data => setForm(data))
        .catch(() => setError("Kullanıcı bilgisi alınamadı."))
        .finally(() => setLoading(false));
    }
  }, [user]);

  const handleChange = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");
    setError("");
    try {
      const res = await fetch(`/api/users/${user.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      if (res.ok) {
        setSuccess("Profil başarıyla güncellendi.");
        login({ ...user, ...form });
      } else {
        setError("Profil güncellenemedi.");
      }
    } catch {
      setError("Sunucuya bağlanılamadı.");
    }
    setLoading(false);
  };

  const handlePasswordChange = async e => {
    e.preventDefault();
    setPasswordSuccess("");
    setPasswordError("");
    setPasswordLoading(true);
    try {
      const res = await fetch(`/api/users/${user.id}/password`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ currentPassword, newPassword })
      });
      if (res.ok) {
        setPasswordSuccess("Şifre başarıyla değiştirildi.");
        setCurrentPassword("");
        setNewPassword("");
        setShowPasswordForm(false);
      } else {
        const data = await res.json();
        setPasswordError(data.error || "Şifre değiştirilemedi.");
      }
    } catch {
      setPasswordError("Sunucuya bağlanılamadı.");
    }
    setPasswordLoading(false);
  };

  const handleDeleteAccount = async () => {
    if (!window.confirm("Hesabınızı ve tüm verilerinizi silmek istediğinize emin misiniz? Bu işlem geri alınamaz.")) return;
    setDeleteLoading(true);
    setDeleteError("");
    setDeleteSuccess("");
    try {
      const res = await fetch(`/api/users/${user.id}`, { method: "DELETE" });
      if (res.ok) {
        setDeleteSuccess("Hesabınız silindi. Çıkış yapılıyor...");
        setTimeout(() => {
          logout();
          window.location.href = "/";
        }, 1500);
      } else {
        setDeleteError("Hesap silinemedi.");
      }
    } catch {
      setDeleteError("Sunucuya bağlanılamadı.");
    }
    setDeleteLoading(false);
  };

  if (!user) return <div>Giriş yapmalısınız.</div>;
  if (!form) return <div>Yükleniyor...</div>;

  return (
    <form onSubmit={handleSubmit} className="max-w-lg mx-auto p-6 bg-white rounded-xl shadow flex flex-col gap-4 mt-10">
      <h2 className="text-xl font-bold mb-2">Profil Bilgilerim</h2>
      {success && <div className="bg-green-100 text-green-800 rounded px-4 py-2">{success}</div>}
      {error && <div className="bg-red-100 text-red-800 rounded px-4 py-2">{error}</div>}
      <input name="name" value={form.name || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Ad Soyad" />
      <input name="firma" value={form.firma || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Firma Ünvanı" />
      <input name="vergiNo" value={form.vergiNo || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Vergi No" />
      <input name="yetkili" value={form.yetkili || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Yetkili" />
      <input name="telefon" value={form.telefon || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Telefon" />
      <input name="adres" value={form.adres || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Adres" />
      <input name="sektor" value={form.sektor || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Sektör" />
      <input name="sicil" value={form.sicil || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Ticaret Sicil No" />
      <input name="web" value={form.web || ""} onChange={handleChange} className="px-3 py-2 border rounded" placeholder="Web Sitesi" />
      <button type="button" className="bg-gray-200 text-blue-900 px-4 py-2 rounded hover:bg-gray-300 transition" onClick={() => setShowPasswordForm(v => !v)}>
        {showPasswordForm ? "Şifre Değiştir'i Kapat" : "Şifre Değiştir"}
      </button>
      {showPasswordForm && (
        <form onSubmit={handlePasswordChange} className="flex flex-col gap-2 bg-blue-50 p-4 rounded-xl mt-2">
          <div className="font-semibold mb-1">Şifre Değiştir</div>
          {passwordSuccess && <div className="bg-green-100 text-green-800 rounded px-4 py-2">{passwordSuccess}</div>}
          {passwordError && <div className="bg-red-100 text-red-800 rounded px-4 py-2">{passwordError}</div>}
          <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="px-3 py-2 border rounded" placeholder="Mevcut Şifre" required />
          <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} className="px-3 py-2 border rounded" placeholder="Yeni Şifre" required />
          <button type="submit" className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 transition" disabled={passwordLoading}>{passwordLoading ? "Kaydediliyor..." : "Şifreyi Değiştir"}</button>
        </form>
      )}
      <button type="button" className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition mt-4" onClick={handleDeleteAccount} disabled={deleteLoading}>
        {deleteLoading ? "Siliniyor..." : "Hesabımı Sil"}
      </button>
      {deleteError && <div className="bg-red-100 text-red-800 rounded px-4 py-2 mt-2">{deleteError}</div>}
      {deleteSuccess && <div className="bg-green-100 text-green-800 rounded px-4 py-2 mt-2">{deleteSuccess}</div>}
      <button type="submit" className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 transition" disabled={loading}>{loading ? "Kaydediliyor..." : "Kaydet"}</button>
    </form>
  );
} 